interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({
  page,
  totalPages,
  onChange,
}: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: number[] = [];
  const start = Math.max(1, Math.min(page - 2, totalPages - 4));
  const end = Math.min(totalPages, start + 4);
  for (let i = start; i <= end; i += 1) pages.push(i);

  return (
    <div className="mt-10 flex items-center justify-center gap-2">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page === 1}
        className="flex h-9 items-center gap-1 whitespace-nowrap rounded-md border border-background-200 px-3 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40"
      >
        <i className="ri-arrow-left-s-line"></i>
        上一页
      </button>

      {start > 1 && (
        <>
          <button
            type="button"
            onClick={() => onChange(1)}
            className="h-9 w-9 rounded-md border border-background-200 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600 cursor-pointer"
          >
            1
          </button>
          {start > 2 && <span className="px-1 text-foreground-400">…</span>}
        </>
      )}

      {pages.map((p) => (
        <button
          key={p}
          type="button"
          onClick={() => onChange(p)}
          className={`h-9 w-9 rounded-md border text-sm font-medium transition-colors cursor-pointer ${
            p === page
              ? "border-primary-500 bg-primary-500 text-background-50"
              : "border-background-200 text-foreground-700 hover:border-primary-400 hover:text-primary-600"
          }`}
        >
          {p}
        </button>
      ))}

      {end < totalPages && (
        <>
          {end < totalPages - 1 && (
            <span className="px-1 text-foreground-400">…</span>
          )}
          <button
            type="button"
            onClick={() => onChange(totalPages)}
            className="h-9 w-9 rounded-md border border-background-200 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600 cursor-pointer"
          >
            {totalPages}
          </button>
        </>
      )}

      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        className="flex h-9 items-center gap-1 whitespace-nowrap rounded-md border border-background-200 px-3 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40"
      >
        下一页
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </div>
  );
}